import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash, FaChevronDown } from "react-icons/fa";
import useRegisterForm from "../../hooks/userRegisterForm";
import backgroundImage from "../../assets/img/fondoUno.png";
import UCPlogo from "../../assets/img/logoUCP2.png";

const PROGRAMAS_POR_FACULTAD = {
  "Facultad de Arquitectura y Diseño": [
    "Diseño Audiovisual",
    "Arquitectura",
    "Diseño Industrial",
    "Especialización en Gestión de Proyectos e Innovación",
    "Especialización en Arquitectura Bioclimática",
    "Especialización en Gestión de la Construcción Sostenible",
    "Maestría en Arquitectura y Urbanismo",
  ],
  "Facultad de Ciencias Humanas, Sociales y de la Educación": [
    "Psicología",
    "Comunicación Social - Periodismo",
    "Licenciatura en Educación Religiosa",
    "Especialización en Pedagogía y Desarrollo Humano",
    "Especialización en Edumática Innovación Educativa Mediada por TIC",
    "Especialización en Gerencia de la Comunicación Corporativa",
    "Especialización en Psicología Clínica. Énfasis en Psicoterapia con niños y adolescentes",
    "Especialización en Psicología Social Comunitaria y Acción Psicosocial",
    "Especialización en Gestión Humana en las Organizaciones",
    "Maestría en Pedagogía y Desarrollo Humano",
    "Maestría en Innovación Educativa",
    "Maestría en Gestión Estratégica de la Comunicación",
    "Maestría en Memoria y Escenarios Transicionales",
    "Doctorado en Educación en Desarrollo Humano",
    "Departamento de Humanidades",
  ],
  "Facultad de Ciencias Básicas e Ingeniería": [
    "Ingeniería de Sistemas y Telecomunicaciones",
    "Ingeniería Industrial",
    "Tecnología en Desarrollo de Software",
    "Departamento de Ciencias Básicas",
  ],
  "Facultad de Ciencias Económicas y Administrativas": [
    "Administración de Empresas",
    "Negocios Internacionales",
    "Mercadeo",
    "Tecnología en Gestión de Mercadeo",
    "Especialización en Finanzas",
    "Especialización en Economía Pública y Gestión Territorial",
    "Maestría en Mercadeo",
    "Maestría en Gestión de Proyectos",
    "Maestría en Gestión del Desarrollo Regional",
    "Maestría en Finanzas",
  ],
  Otro: ["Otro"],
};

function RegisterUser() {
  const navigate = useNavigate();

  const {
    usuario,
    showPassword,
    error,
    successMessage,
    handleChange,
    togglePasswordVisibility,
    handleSubmit,
  } = useRegisterForm();

  const handleLogout = () => {
    localStorage.removeItem("UsuarioIniciado");
    localStorage.removeItem("filtrosExperiencias");
    navigate("/login");
  };

  const programas =
    usuario.facultad && PROGRAMAS_POR_FACULTAD[usuario.facultad]
      ? PROGRAMAS_POR_FACULTAD[usuario.facultad]
      : [];

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md mx-4 my-8">
        <div className="flex mb-4">
          <img src={UCPlogo} alt="UCP Logo" className="h-28 w-auto" />
        </div>

        {successMessage ? (
          <div className="text-green-600 text-center font-bold mb-4">
            {successMessage}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-3">
            <h1 className="text-2xl font-extrabold font-montserrat mb-4">
              Registrar Usuario
            </h1>
            {error && <p className="text-red-500 text-sm">{error}</p>}

            <div className="flex items-center mb-3">
              <div className="flex-grow h-1 rounded bg-green-700"></div>
              <span className="px-2 text-green-700 font-mono font-bold">
                FILOSOFIA INSTITUCIONAL
              </span>
            </div>

            {/* NOMBRE / APELLIDOS */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="relative">
                <strong>Nombre:</strong>
                <input
                  type="text"
                  name="nombre"
                  value={usuario.nombre || ""}
                  onChange={handleChange}
                  placeholder="Nombre"
                  required
                  className="w-full p-2 border rounded text-sm"
                />
              </div>
              <div className="relative">
                <strong>Apellidos:</strong>
                <input
                  type="text"
                  name="apellidos"
                  value={usuario.apellidos || ""}
                  onChange={handleChange}
                  placeholder="Apellidos"
                  required
                  className="w-full p-2 border rounded text-sm"
                />
              </div>

              {/* TIPO DOC / NÚMERO / CARGO */}
              <div className="relative">
                <strong>Tipo de documento:</strong>
                <select
                  name="tipocc"
                  value={usuario.tipocc || ""}
                  onChange={handleChange}
                  required
                  className="w-full p-2 pr-8 border rounded text-sm appearance-none"
                >
                  <option value="" disabled>
                    Seleccione…
                  </option>
                  <option value="Cédula de Ciudadanía">
                    Cédula de Ciudadanía
                  </option>
                  <option value="Tarjeta de Identidad">
                    Tarjeta de Identidad
                  </option>
                  <option value="Cédula de Extranjería">
                    Cédula de Extranjería
                  </option>
                </select>
                <FaChevronDown className="absolute right-3 top-10 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
              </div>

              <div className="relative">
                <strong>Número de documento:</strong>
                <input
                  type="number"
                  name="numcc"
                  value={usuario.numcc || ""}
                  onChange={handleChange}
                  placeholder="Número de documento"
                  required
                  className="w-full p-2 border rounded text-sm"
                />
              </div>

              <div className="relative col-span-1 md:col-span-2">
                <strong>Cargo/Ocupación:</strong>
                <select
                  name="rol"
                  value={usuario.rol || ""}
                  onChange={handleChange}
                  required
                  className="w-full p-2 pr-8 border rounded text-sm appearance-none"
                >
                  <option value="" disabled>
                    Selecciona el cargo/ocupación
                  </option>
                  <option>Estudiante</option>
                  <option>Docente de planta</option>
                  <option>Docente de cátedra</option>
                  <option>Administrativo</option>
                  <option>Administrador</option>
                </select>
                <FaChevronDown className="absolute right-3 top-10 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
              </div>

              {/* CORREO */}
              <div className="relative">
                <strong>Correo:</strong>
                <input
                  type="email"
                  name="correo"
                  value={usuario.correo || ""}
                  onChange={(e) => {
                    // normalizamos a minúsculas como en el original
                    e.target.value = e.target.value.toLowerCase();
                    handleChange(e);
                  }}
                  placeholder="example@ucp.edu.co"
                  required
                  className="w-full p-2 border rounded text-sm"
                />
              </div>

              {/* CONTRASEÑA (name=password) */}
              <div className="relative">
                <strong>Contraseña:</strong>
                <input
                  type={showPassword ? "text" : "password"}
                  name="contrasena"
                  value={usuario.contrasena || ""}
                  onChange={handleChange}
                  placeholder="••••••••••"
                  required
                  className="w-full p-2 pr-8 border rounded text-sm"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute right-3 top-[65%] transform -translate-y-1/2 text-black"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

              {/* FACULTAD */}
              <div className="relative">
                <strong>Facultad:</strong>
                <select
                  name="facultad"
                  value={usuario.facultad || ""}
                  onChange={handleChange}
                  required
                  className="w-full p-2 pr-8 border rounded text-sm appearance-none"
                >
                  <option value="" disabled>
                    Seleccione la facultad
                  </option>
                  <option value="Facultad de Arquitectura y Diseño">
                    Facultad de Arquitectura y Diseño
                  </option>
                  <option value="Facultad de Ciencias Humanas, Sociales y de la Educación">
                    Facultad de Ciencias Humanas, Sociales y de la Educación
                  </option>
                  <option value="Facultad de Ciencias Básicas e Ingeniería">
                    Facultad de Ciencias Básicas e Ingeniería
                  </option>
                  <option value="Facultad de Ciencias Económicas y Administrativas">
                    Facultad de Ciencias Económicas y Administrativas
                  </option>
                  <option value="Otro">Otro</option>
                </select>
                <FaChevronDown className="absolute right-3 top-10 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
              </div>

              {/* PROGRAMA (dependiente de facultad) */}
              <div className="relative">
                <strong>Programa:</strong>
                <select
                  name="programa"
                  value={
                    usuario.programa ||
                    (usuario.facultad ? "" : "Esperando facultad...")
                  }
                  onChange={handleChange}
                  required
                  disabled={!usuario.facultad}
                  className="w-full p-2 pr-8 border rounded text-sm appearance-none disabled:bg-gray-100"
                >
                  {!usuario.facultad && (
                    <option value="Esperando facultad...">
                      Esperando facultad...
                    </option>
                  )}
                  {usuario.facultad &&
                    programas.map((p) => (
                      <option key={p} value={p}>
                        {p}
                      </option>
                    ))}
                </select>
                <FaChevronDown className="absolute right-3 top-10 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
              </div>

              {/* ROL (radios) */}
              {/* <div className="relative col-span-1 md:col-span-2">
                <strong>Rol:</strong>
                <div className="flex items-center gap-6 mt-2">
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="rol"
                      value="Admin"
                      checked={usuario.rol === "Admin"}
                      onChange={handleChange}
                      required
                    />
                    <span>Administrador</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="rol"
                      value="Usuario"
                      checked={usuario.rol === "Usuario"}
                      onChange={handleChange}
                      required
                    />
                    <span>Usuario</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="rol"
                      value="Evaluador"
                      checked={usuario.rol === "Evaluador"}
                      onChange={handleChange}
                      required
                    />
                    <span>Evaluador</span>
                  </label>
                </div>
              </div> */}
            </div>

            <div className="flex justify-center">
              <button
                type="submit"
                className="w-full bg-green-700 text-white p-2 rounded hover:bg-green-600"
              >
                Registrar
              </button>
            </div>

            {/* Botonera inferior estilo original */}
            <div className="flex gap-3 justify-between mt-4">
              <button
                type="button"
                onClick={handleLogout}
                className="flex-1 border rounded p-2 text-sm"
              >
                Cerrar sesión
              </button>
              <Link
                to="/admin/lista-usuarios"
                className="flex-1 text-center border rounded p-2 text-sm"
              >
                Control de usuarios
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default RegisterUser;
